// extracted by mini-css-extract-plugin
export default {"inputWrapper":"sNXmA"};